// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerWrapper_spinner__zD1is"};